import { Calendar } from "lucide-react";

export const NoGames = () => (
  <div className="text-center py-8 sm:py-12">
    <Calendar size={48} className="mx-auto text-gray-400 mb-4" />
    <h3 className="text-lg font-medium text-gray-900">No Games Found</h3>
    <p className="text-gray-600 mt-1 px-4">
      Either no games have been played on this date, or data is not available
      yet.
    </p>
  </div>
);